<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.procedimentoApac"
            ref="DataTable"
            sort-by="unidadeExecutanteNomeFantasia"
            search-by="unidadeExecutanteNomeFantasia"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :title="!item.exportado ? 'Editar' : 'Visualizar'"
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    authorize="update-apac-procedimento"
                >
                    <rkm-icon :icon="!item.exportado ? 'pen' : 'eye'" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.exportado"
                    @click="handleDestroy(item.id)"
                    color="danger"
                    small
                    title="Excluir"
                    authorize="destroy-apac-procedimento"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <Modal
            @close="$refs.DataTable.refresh()"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './components/cadastro/Modal.vue'

// Mixins.
import { repository, formats } from '@/mixins'

export default {
    components: { Modal },
    created() {

        this.repositories = {
            procedimentoApac: this.getConectaSusRepository('apac.procedimento'),
        }
    },
    data() {

        return {
            fields: [
                { key: 'unidadeExecutanteNomeFantasia', name: 'unidadeExecutante.nomeFantasia', label: 'Unidade executante', searchable: true, sortable: true },
                { key: 'competenciaValor', name: 'competencia.valor', label: 'Competência', searchable: true, sortable: true },
                { key: 'dataProcessamento', name: 'solicitacaoAutorizacao.dataProcessamento', label: 'Data de processamento', searchable: true, sortable: true },
                { key: 'numeroApac', name: 'solicitacaoAutorizacao.numeroApac', label: 'Número da APAC', searchable: true, sortable: true },
                { key: 'pacienteNome', name: 'pacienteCidadao.nome', label: 'Paciente', searchable: true, sortable: true },
                { key: 'procedimentoPrincipalCodigo', name: 'procedimentoPrincipal.codigo', label: 'Procedimento', searchable: true, sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        refresh() {

            this.$refs.DataTable.refresh()
        },
        handleDestroy(id) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o procedimento?',
                () => this.repositories.procedimentoApac.destroy(id).then(() => this.$refs.DataTable.refresh())
            )
        },
    },
    mixins: [repository, formats],
}
</script>